import { useSelector } from "react-redux";
import { useContext } from "react";

import useStoreCurrencyConverter from "@hooks/currency/use-store-currency-converter";

import Accordion from "@stadium/ui/src/components/accordion/accordion";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import { getStoreCurrencyCode } from "@selectors/store";

import styles from "./main.module.scss";

const DiscountTableEnum = {
  Range: "range",
  Discount: "discount",
  Amount: "amount",
};

export const ProductDiscountTable = ({ rangeHeading = "Qty", tableData }) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const storeCurrencyCode = useSelector(getStoreCurrencyCode);

  const { formatPriceInDisplayStoreCurrency } = useStoreCurrencyConverter();

  const renderVolumeDiscountTable = () => (
    <div className={styles.discountTableWrapper}>
      <div className={styles.buyMoreSaveMore}>
        Buy more, save more! Get a volume discount on this product when more are ordered.
      </div>
      <div className={styles.bulkTableWrapper}>
        <div className={styles.bulkTable}>
          {tableData.map((data, index) => {
            const isHighestRange = index === tableData.length - 1;
            const { id, discount, amount, range } = data;
            return (
              <div key={`discount-table-${id}`} className={styles.bulkTableRow}>
                <div
                  data-label={rangeHeading}
                  className={styles.bulkTableCell}
                  aria-label="Quantity"
                >
                  <span className={styles.bulkTableCellVal}>
                    {getPriceValue({ range, isHighestRange }, DiscountTableEnum.Range)}
                  </span>
                </div>
                <div data-label="Price" className={styles.bulkTableCell} aria-label="Price">
                  <span className={styles.bulkTableCellVal}>
                    {formatPriceInDisplayStoreCurrency(
                      getPriceValue({ amount }, DiscountTableEnum.Amount),
                      storeCurrencyCode,
                    )}
                  </span>
                </div>
                <div data-label="Discount" className={styles.bulkTableCell} aria-label="Discount">
                  <span className={styles.bulkTableCellVal}>
                    {getPriceValue({ discount }, DiscountTableEnum.Discount)}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );

  if (isMobileDevice)
    return (
      <Accordion
        id="volume-discounts"
        customClass={`${styles.panelGroup} ${styles.withRevamp}`}
        titleContent={
          <div className={styles.acord}>
            <div className={styles.primaryColor}>Volume Discounts</div>
            <div className={`${styles.iconChevronUp} collapseicon`}></div>
          </div>
        }
      >
        {renderVolumeDiscountTable()}
      </Accordion>
    );

  return renderVolumeDiscountTable();
};

const getPriceValue = ({ discount, range, amount, isHighestRange }, key) => {
  const discountOff = `${discount}% off`;
  if (key === DiscountTableEnum.Range) {
    if (isHighestRange) {
      return `${range.min}+`;
    }
    return `${range.min} - ${range.max}`;
  }
  if (key === DiscountTableEnum.Discount) {
    return `${discount ? discountOff : "--"}`;
  }
  return amount;
};
